import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import CourseTile from "../../../Courses/CourseTile/CourseTile";
import { getStudentWishlist } from "../../../../_actions/cart.actions";

const Wishlist = () => {
  const dispatch = useDispatch();
  const studentWishlist = useSelector((state) => state?.cart?.wishlistItems);

  useEffect(() => {
    dispatch(getStudentWishlist());
  }, []);

  return (
    <div className="content-inner-wrapper">
      <div className="tile-column">
        {studentWishlist?.length > 0 ? (
          studentWishlist?.map((post, index) => (
            <CourseTile key={index} post={post} />
          ))
        ) : (
          <>
            <div className="no-record-wishlist">
              <span className="recordNotFound">No Record found</span>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Wishlist;
